<script setup>
import { ref, reactive } from 'vue';
import BlogCard from "@/Shared/BlogCard";
import Pagination from "@/Shared/Pagination";
import TabNavigator from "@/Shared/Navigation/TabNavigator";

let props = defineProps({
    blogs: Object,
    blogTypes: Object,
    current: null
});

let tabNavigation = [
    { name: 'All', href: route('blog.index', {'type':'all'}), current: (props.current === 'all') },
];
props.blogTypes.forEach((blogType) => {
    tabNavigation.push({
        name: blogType.label,
        href: route('blog.index', {'type':blogType.value}),
        current: (props.current === blogType)
    })
})
</script>

<template>
    <div class="w-full relative">
        <TabNavigator :tabs="tabNavigation" />
        <h2 class="text-white text-3xl font-bold mt-12 sm:mt-16 text-center px-2">Our latest blog articles and news</h2>
        <div class="flex flex-col mt-14 sm:mt-28 relative">
            <ul class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                <BlogCard v-for="blog in blogs.data" :blog="blog"></BlogCard>
            </ul>
            <pagination class="flex" :meta="blogs.meta"/>
        </div>
    </div>
</template>
